import React from 'react';
import PropTypes from 'prop-types';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMSplitViewMixin from 'components/mixins/SMSplitViewMixin';
import SMFormSpaceSelectBox from 'components/dashboard/form/SMFormSpaceSelectBox';
import SMFormRoomSelectBox from 'components/dashboard/form/SMFormRoomSelectBox';
import sprintf from 'sprintf';
import SMConst from 'lib/SMConst';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMHistoryHelper from 'components/helpers/SMHistoryHelper';
import SMReservationHelper from 'components/helpers/SMReservationHelper';
import SMOReservationListTableRow from './SMOReservationListTableRow';
import SMOEmbeddedCalendarView from './SMOEmbeddedCalendarView';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import Spinner from 'components/shared/SMMaterialSpinner';
import reactMixin from 'react-mixin';
import SMOICalendarUrlView from 'components/dashboard/owners/reservations/SMOICalendarUrlView';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMOReservationCalendarView extends SMDashboardBaseView {

  constructor(props) {
    super(props);
    let now = new Date(),
        year = this.props.year || now.getFullYear(),
        month = this.props.month ? this.props.month - 1 : now.getMonth(),
        calendarDate = new Date(year, month, 1);
    this.state = {
      display: this.props.display,
      owner: this.props.owner.attributes,
      spaceId: this.props.spaceId,
      roomId: this.props.roomId,
      calendarDate: calendarDate,
      selectedDate: null,
      listItems: [],
      listItemsPerDay: {},
      pushStateUrl: "",
    };
  }

  toYMD(date, divider){
    divider = divider || "";
    let y = date.getFullYear(),
        m = date.getMonth() + 1,
        d = date.getDate();
    return sprintf("%04d%s%02d%s%02d", y, divider , m , divider , d);
  }

  componentDidMount() {
    $('body').addClass('js-split-view');
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    this.requestCalendarResource();
    SMRenderHelper.addObserverForBaloon();
    this.addSplitViewModal(this.refs.mainTable);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }

  sizeToFit(e) {
    let $mainTable = $(this.refs.mainTable),
        $navigationTable = $(this.refs.navigationTable),
        $navigationTableFooter = $(this.refs.navigationTableFooter);

    $navigationTable.outerHeight(this.navigationTableHeight() - $navigationTableFooter.outerHeight());
    $mainTable.outerHeight(this.mainTableHeight() + 5);
  }

  spaceSelectBoxDidChangeValue(value) {
    this.setState({
      spaceId: value,
      roomId: "",
      selectedDate: null,
      listItems: [],
      listItemsPerDay: {},
    });
  }

  roomSelectBoxDidChangeValue(value) {
    this.setState({
      roomId: value,
      selectedDate: null,
      listItems: [],
      listItemsPerDay: {},
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.spaceId != prevState.spaceId ||
      this.state.roomId != prevState.roomId ||
      this.state.calendarDate != prevState.calendarDate) {
      this.requestCalendarResource();
    }

    if (this.state.pushStateUrl != prevState.pushStateUrl) {
      SMHistoryHelper.replaceState(this.state.pushStateUrl, this.state);
    }
    this.sizeToFit();
  }

  requestCalendarResource(){

    if (this.state.display == SMConst.Display.Loading) return;
    this.setState({display: SMConst.Display.Loading});
    let queries = {};
    if (this.state.spaceId) queries["space_id"] = this.state.spaceId;
    if (this.state.roomId) queries["room_id"] = this.state.roomId;

    let pushQueries = queries;
    pushQueries["year"] = this.state.calendarDate.getFullYear();
    pushQueries["month"] = this.state.calendarDate.getMonth() + 1;
    let pushStateUrl = Routes.owner_dashboard_path(this.state.owner.username, pushQueries);

    $(this.refs.calendar).startLoading();
    SMOwnerResource.getCalendar(this.state.owner.username, queries, (calendars, error, xhr)=>{
      $(this.refs.calendar).stopLoading();
      this.setState({display: SMConst.Display.Visible});
      if(error || !calendars) return;
      let listItemsPerDay = {};
      for (let i = 0; i < calendars.length; i++) {
        let calendar = calendars[i];
        let key = sprintf('%02d-%02d-%02d', calendar.year, calendar.month, calendar.day);
        for (let j = 0; j < calendar.reservations.length; j++) {
          let reservation = calendar.reservations[j];
          if (SMReservationHelper.isDayTimeConfirmed(reservation)
            || SMReservationHelper.isStayConfirmed(reservation)
            || SMReservationHelper.isDayTimeRequested(reservation)
            || SMReservationHelper.isStayRequested(reservation)) {
            if (!listItemsPerDay[key]) listItemsPerDay[key] = [];
            listItemsPerDay[key].push(reservation);
          }
        }

        for (let k = 0; k < calendar.imported_schedules.length; k++) {
          let imported_schedule = calendar.imported_schedules[k];
          if (!listItemsPerDay[key]) listItemsPerDay[key] = [];
          listItemsPerDay[key].push(imported_schedule);
        }

        for (let k = 0; k < calendar.block_schedules.length; k++) {
          let block_schedule = calendar.block_schedules[k];
          if (!listItemsPerDay[key]) listItemsPerDay[key] = [];
          listItemsPerDay[key].push(block_schedule);
        }
      }

      this.setState({
        listItemsPerDay: listItemsPerDay,
        pushStateUrl: pushStateUrl,
      });
    });
  }

  renderInit() {
    return null;
  }

  renderList() {
    if (this.state.listItems.length > 0) {
      let reservationList = [];
      for (let rowIndex = 0; rowIndex < this.state.listItems.length; rowIndex++) {
        let reservation = this.state.listItems[rowIndex];
        reservationList.push(
          <SMOReservationListTableRow
            key={rowIndex+'-'+reservation.id}
            owner={this.state.owner}
            target="_blank"
            reservation={reservation}
            delegate={this}
            rowIndex={rowIndex} />
        );
      }
      return <ul>{reservationList}</ul>;
    }
    return <p className="dashboard-sidecol__scrollarea-nodata">予約はありません。</p> ;
  }

  tableDidSelectRowAtIndex(selectedRowIndex, e){
    let reservation = this.state.listItems[selectedRowIndex];
    //window.location = Routes.owner_dashboard_reservation_path(reservation.owner.username, reservation.uid);
  }

  renderCalendar() {

    let year = this.state.calendarDate.getFullYear(),
        month = this.state.calendarDate.getMonth();
    let startedAt = new Date(year, month, 1),
        prevLast = new Date(year, month, 0).getDate();
    let endedAt = new Date(year, month + 1, 0),
        last = endedAt.getDate();
    let status = "prev" ,
        date = startedAt.getDate() - startedAt.getDay(),
        rows = [];
    let now = new Date();

    for (let row = 0; row < 6; row++){
      let cols = [];
      for (let col = 0; col < 7; col++) {
        let label = "";
        if (row == 0 && startedAt.getDay() == col) status = "current";
        if (date > endedAt.getDate()) {
          if (status == "next" && col == 0) break;
          status = "next";
        }

        let classes = [],
            current;
        if (status == "prev") {
          classes.push("is-past");
          label = prevLast + date;
          current = new Date(year, month - 1, label);
          date++;
        } else if (status == "next") {
          classes.push("is-past");
          label = date - last;
          current = new Date(year, month + 1, label);
          date++;
        } else {
          label = date++;
          current = new Date(year, month, label);
        }

        if (this.toYMD(current) < this.toYMD(now)) {
          classes.push("is-past");
        }
        if (this.toYMD(current) == this.toYMD(now)) {
          classes.push("is-today");
        }
        if (this.state.selectedDate && this.toYMD(this.state.selectedDate) == this.toYMD(current)) {
          classes.push("is-current");
        }

        if (col == 0 || col == 6) classes.push("is-holiday");

        let key = this.toYMD(current, "-");
        let contents = [],
            reservations = this.state.listItemsPerDay[key];
        if (reservations) {
          let daytimeConfirmed = 0, requested = 0, imported = 0, blocked = 0, stayConfirmed = 0;
          for (let i = 0; i < reservations.length; i++) {
            let reservation = reservations[i];
            if (SMReservationHelper.isImportedSchedule(reservation)) {
              imported++;
            } else {
              if (SMReservationHelper.isBlockSchedule(reservation)) {
                blocked++;
              } else {
                if (SMReservationHelper.isDayTimeConfirmed(reservation)) daytimeConfirmed++;
                if (SMReservationHelper.isStayConfirmed(reservation)) stayConfirmed++;
                if (SMReservationHelper.isDayTimeRequested(reservation) || SMReservationHelper.isStayRequested(reservation)) requested++;
              }
            }
          }
          if (stayConfirmed > 0) {
            contents.push(<p key="0" className="is-approval">{sprintf("%d件の承認済み(宿泊)", stayConfirmed)}</p>);
          }
          if (daytimeConfirmed > 0) {
            contents.push(<p key="1" className="is-approval">{sprintf("%d件の承認済み(レンタル)", daytimeConfirmed)}</p>);
          }
          if (requested > 0) {
            contents.push(<p key="2" className="is-reserve">{sprintf("%d件の保留", requested)}</p>);
          }
          if (imported > 0) {
            contents.push(<p key="3" className="is-reserve">{sprintf("%d件の予定", imported)}</p>);
          }
          if (blocked > 0) {
            contents.push(<p key="4" className="is-reserve">{sprintf("%d件のブロック", blocked)}</p>);
          }
        }

        cols.push(
          <td key={key} className={classes.join(" ")}>
            <a onClick={this.dayDidSelect.bind(this)} href="#" data-date={key} className="dashboard-calendar__cell-wrap">
              <p className="dashboard-calendar__date">{label}</p>
              <div className="dashboard-calendar__content">
                {contents}
              </div>
            </a>
          </td>
        );
      }
      rows.push(
        <tr key={row}>{cols}</tr>
      );
    }
    return rows;

  }

  dayDidSelect(e){
    e.preventDefault();
    let key = $(e.currentTarget).data("date"),
        selectedDate = new Date(key),
        reservations = this.state.listItemsPerDay[key];
    this.setState({
      selectedDate: selectedDate,
      listItems: reservations || [],
    });

  }

  loadPrevMonth(e) {
    e.preventDefault();
    let date = new Date(
      this.state.calendarDate.getFullYear(),
      this.state.calendarDate.getMonth() - 1,
      1
    );
    this.setState({
      calendarDate: date,
      selectedDate: null,
      listItems: [],
      listItemsPerDay: {},
    });
  }

  loadCurrentMonth(e) {
    e.preventDefault();
    let date = new Date();
    this.setState({
      calendarDate: new Date(date.getFullYear(), date.getMonth(), 1),
      selectedDate: date,
      listItems: [],
      listItemsPerDay: {},
    });
  }

  loadNextMonth(e) {
    e.preventDefault();
    let date = new Date(
      this.state.calendarDate.getFullYear(),
      this.state.calendarDate.getMonth() + 1,
      1
    );
    this.setState({
      calendarDate: date,
      selectedDate: null,
      listItems: [],
      listItemsPerDay: {},
    });
  }

  renderDateSelect(){
    let rows = [];
    let d = new Date(this.toYMD(this.state.calendarDate, "-"));
    d.setMonth(d.getMonth() + 6);
    for (let i = 0; i < 12; i++) {
      let label = sprintf(I18n.t("datetime.label_000001"), d.getFullYear(), d.getMonth() + 1),
          value = this.toYMD(d, "-");
      rows.push(
        <option key={value} value={value}>{label}</option>
      );
      d.setMonth(d.getMonth() - 1);
    }

    return rows;
  }

  renderFooterLinks(){
    if (this.state.spaceId && this.state.roomId) {
      return(
        <p className="ta-r mb30">
          <a href="#" className="link-hover-border" onClick={this.showEmbeddedCalendar.bind(this)}>{I18n.t('dashboard.label_000301')}</a>
          <span className="link-separator">|</span>
          <a href="#" className="link-hover-border" onClick={this.showICalendarUrl.bind(this)}>{I18n.t('dashboard.label_000206')}</a>
          <span className="link-separator">|</span>
          <a href={Routes.owner_dashboard_settings_calendar_path(this.state.owner.id)} className="link-hover-border">{I18n.t('dashboard.label_000016')}</a>
        </p>
      );
    } else {
      return(
        <p className="ta-r mb30">
          <a href={Routes.owner_dashboard_settings_calendar_path(this.state.owner.id)} className="link-hover-border">{I18n.t('dashboard.label_000016')}</a>
        </p>
      );
    }
  }

  showEmbeddedCalendar(e) {
    e.preventDefault();
    this.showDialog(<SMOEmbeddedCalendarView owner={this.state.owner} roomId={this.state.roomId} delegate={this} />);
  }

  showICalendarUrl(e) {
    e.preventDefault();
    this.showDialog(<SMOICalendarUrlView owner={this.state.owner} roomId={this.state.roomId} />);
  }

  calendarDateDidChange(e) {
    this.setState({calendarDate: new Date(e.currentTarget.value)});
  }

  buildDateQuery() {
    let query = {};

    if (this.state.spaceId) query.space_id = this.state.spaceId;
    if (this.state.roomId) query.room_id = this.state.roomId;
    if (this.state.selectedDate) {
      query.year = this.state.selectedDate.getFullYear();
      query.month = this.state.selectedDate.getMonth() + 1;
      query.day = this.state.selectedDate.getDate();
    }

    return query;
  }

  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  renderLoading() {
    return (
      <div className="js-empty"><Spinner /></div>
    );
  }

  render() {

    let owner = this.state.owner,
        navigationTable,
        dateString = "";

    if (this.state.selectedDate) {
      dateString = sprintf("%d月%d日",
        this.state.selectedDate.getMonth() + 1,
        this.state.selectedDate.getDate()
      );
    }

    if (this.state.display == SMConst.Display.Loading) navigationTable = this.renderLoading();
    else if (!this.state.selectedDate) navigationTable = this.renderInit();
    else navigationTable = this.renderList();

    return (
      <div className="dashboard-container clearfix mb30">
        <div className="dashboard-sidecol fr">
          <h2 className="dashboard-title mt25 mb25 ml20">{dateString}</h2>
          <div ref="navigationTable" className="js-scroller dashboard-sidecol__scrollarea">
            {navigationTable}
          </div>
          <div ref="navigationTableFooter" className="dashboard-sidecol__buttonarea-bottom">
            <a onClick={this.trackPageEvent.bind(this, 'od new block_reservation')} href={Routes.new_owner_dashboard_block_path(owner.username, this.buildDateQuery())} className="button-green dashboard-sidecol__buttonarea-button">
              <i className="fa fa-plus pr5" />{I18n.t("dashboard.label_000157")}
            </a>
            <p className="dashboard-sidecol__buttonarea-help">
              <a onClick={this.trackPageEvent.bind(this, 'od help block_reservation')} href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.ReservationBlock)} className="link-hover-border" target="_blank"><i className="fa fa-question-circle pr5"></i>{I18n.t("dashboard.label_000159")}</a>
            </p>
          </div>
        </div>

        <div id="js-split_view-main" ref="mainTable" className="js-scroller dashboard-maincol__left">

          <div className="calendar-header">
            <h2 className="mb15 mr20 fl">
              <span className="form-select__inner calendar-header__select mr5">
                <label className="form-select">
                  <select onChange={this.calendarDateDidChange.bind(this)} className="w140" value={this.toYMD(this.state.calendarDate, "-")}>
                    {this.renderDateSelect()}
                  </select>
                </label>
              </span>
              <span className="dashboard-title">の予約</span>
            </h2>
            <p className="fl">
              <a onClick={this.loadPrevMonth.bind(this)} href="#" className="button-blue calendar-header__button calendar-header__button-arrow"><i className="fa fa-angle-left"></i></a>
              <a onClick={this.loadCurrentMonth.bind(this)} href="#" className="button-blue  calendar-header__button">{I18n.t("dashboard.label_000122")}</a>
              <a onClick={this.loadNextMonth.bind(this)} href="#" className="button-blue calendar-header__button calendar-header__button-arrow"><i className="fa fa-angle-right"></i></a>
            </p>

            <div className="fr">
              <span className="form-select__inner mr10">
                <label className="form-select">
                  <SMFormSpaceSelectBox
                    ownerId={owner.username}
                    spaceId={this.state.spaceId}
                    options={{className:"w200"}}
                    delegate={this} />
                </label>
              </span>
              <span className="form-select__inner">
                <label className="form-select">
                  <SMFormRoomSelectBox
                    ownerId={owner.username}
                    spaceId={this.state.spaceId}
                    roomId={this.state.roomId}
                    options={{className:"w200"}}
                    delegate={this} />
                </label>
              </span>
            </div>

          </div>

          <table ref="calendar" className="dashboard-calendar__table mb15">
            <tbody>
              <tr>
                <th className="is-holiday">{I18n.t("datetime.Sun")}</th>
                <th className=""><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Mon")}</div></th>
                <th className=""><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Tue")}</div></th>
                <th className=""><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Wed")}</div></th>
                <th className=""><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Thu")}</div></th>
                <th className=""><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Fri")}</div></th>
                <th className="is-holiday">{I18n.t("datetime.Sat")}</th>
              </tr>
              {this.renderCalendar()}
            </tbody>
          </table>
          {this.renderFooterLinks()}
        </div>
      </div>
    );
  }
}
SMOReservationCalendarView.propTypes = {
  owner: PropTypes.object.isRequired,
  spaceId: PropTypes.string,
  roomId: PropTypes.string,
  year: PropTypes.string,
  month: PropTypes.string,
};
SMOReservationCalendarView.defaultProps = {
  display: SMConst.Display.Visible,
};
reactMixin(SMOReservationCalendarView.prototype, SMSplitViewMixin);
export default SMOReservationCalendarView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOReservationCalendarView.jsx